<template>
  <div class="animated revealUp font-weight-bold" style="zoom: 0.9">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("add") }} {{ $t("movie_pass") }}</div>
      <router-link class="btn-blue" to="/"
        >{{ $t("movie_pass") }} {{ $tc("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <section class="mb-2">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.pass_details
          >
            <span class="fs">Movie Pass Details</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse id="pass_details" v-model="sectionCollapse.pass_details">
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-lg-4 col-xl-3 mb-1">
                <div class="input-material">
                  <input
                    v-model="moviePassObj.pass_name"
                    v-validate="'required'"
                    name="pass_name"
                    id="pass_name"
                    placeholder="."
                    type="text"
                  />
                  <label>{{ $t("name") }}</label>
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('pass_name')">{{
                    errors.first("pass_name")
                  }}</span>
                </p>
              </div>

              <div class="col-lg-4 col-xl-3 mb-1">
                <div class="input-material d-flex align-items-center">
                  <input
                    v-model="moviePassObj.alt_pass_name"
                    name="alt_pass_name"
                    id="alt_pass_name"
                    placeholder="."
                    type="text"
                    v-b-tooltip.hover
                    :title="$t('info')"
                  />
                  <label>Alt. Name</label>
                </div>
                <p class="error_message"></p>
              </div>
              <template v-if="showErpColumns">
                <div class="col-lg-3 col-xl-2 mb-1">
                  <div class="input-material">
                    <input
                      v-model="moviePassObj.report_code"
                      name="report_code"
                      id="report_code"
                      placeholder="."
                      type="text"
                    />
                    <label>Report Code</label>
                  </div>
                  <p class="error_message"></p>
                </div>
                <div class="col-lg-3 col-xl-2 mb-1">
                  <div class="input-material">
                    <input
                      v-model="moviePassObj.gl_account"
                      name="gl_account"
                      id="gl_account"
                      placeholder="."
                      type="text"
                    />
                    <label>Gl Account</label>
                  </div>
                  <p class="error_message"></p>
                </div>
                <div class="col-lg-3 col-xl-2 mb-1">
                  <div class="input-material">
                    <input
                      v-model="moviePassObj.gl_desc"
                      name="gl_desc"
                      id="gl_desc"
                      placeholder="."
                      type="text"
                    />
                    <label>Gl Desc</label>
                  </div>
                  <p class="error_message"></p>
                </div>
              </template>

              <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <div class="d-flex align-items-center">
                  <div class="font-weight-bold">{{ $t("expiry") }}</div>
                  <div class="dropdown-curve-container mx-2">
                    <b-dropdown
                      :text="moviePassObj.selectedExpiry['expiry_name']"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        v-for="(levels, levelIndex) in expiryArray"
                        :key="levelIndex"
                        @click="onSelectLevel(levels)"
                        >{{ levels["expiry_name"] }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                  <div class="input-material-sm">
                    <input
                      class="text-right"
                      v-model="moviePassObj.expiry_value"
                      type="number"
                      name="expiryvalue"
                      id="expiryvalue"
                      v-if="moviePassObj.selectedExpiry['show_input']"
                    />
                  </div>
                </div>
              </div>

              <div
                class="col-lg-2 col-xl-1 align-self-center mb-1"
                style="padding-bottom: 15px"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <b-form-checkbox
                    class="j-checkbox pb-0"
                    v-model="moviePassObj.pass_is_active"
                    unchecked-value="N"
                    value="Y"
                  ></b-form-checkbox>
                  <span class="ml-1">{{
                    moviePassObj.pass_is_active === "Y" ? "Active" : "Deactive"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.pass_config
          >
            <span class="fs">
              {{ $t("movie_pass") }} {{ $tc("configuration", 1) }}</span
            >
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse id="pass_config" v-model="sectionCollapse.pass_config">
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-12" style="margin-left: 1px">
                <div
                  v-for="(offerConfigObj,
                  offerConfigIndex) in moviePassObj.offer_config"
                  :key="offerConfigIndex"
                  class="d-flex back_white mx-3 align-items-center py-2 px-4 oc_inp_group_row"
                >
                  <div class="d-flex align-items-center mr-2">
                    <div class="mx-2">
                      <b-form-radio
                        value="TICKET"
                        class="j-radio"
                        v-model="offerConfigObj.type_name"
                      >
                        <div>{{ "TICKET" }}</div>
                      </b-form-radio>
                    </div>
                    <div class="mx-2">
                      <b-form-radio
                        value="FNB"
                        class="j-radio"
                        v-model="offerConfigObj.type_name"
                      >
                        <div>{{ "FNB" }}</div>
                      </b-form-radio>
                    </div>
                  </div>
                  <div class="oc_inp_group">
                    <div class="d-flex align-items-center">
                      <span class="font-weight-bold">{{ "GET" }}</span
                      >&nbsp;
                      <div class="input-material-sm mx-1 oc_input">
                        <input
                          v-validate="'required|numeric'"
                          :name="`c_qty_${offerConfigIndex}`"
                          :id="`c_qty_${offerConfigIndex}`"
                          v-model="offerConfigObj.c_qty"
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-4 col-xl-2 mb-xl-0"
                    v-if="offerConfigObj.type_name == 'TICKET'"
                  >
                    <custommultiselect
                      v-model="offerConfigObj.selected_sstg_group"
                      :options="ScreenSeatTypeGroups"
                      :placeholder="'Seat Type'"
                      label="sstg_name"
                      isSingleId="sstg_id"
                      :multiple="false"
                      track-by="sstg_id"
                      @select="
                        onSelectSeatTypeGroup($event, offerConfigIndex, 'ADD')
                      "
                      @remove="
                        onSelectSeatTypeGroup(
                          $event,
                          offerConfigIndex,
                          'REMOVE'
                        )
                      "
                    ></custommultiselect>
                  </div>
                  <div
                    class="col-lg-4 col-xl-2 mb-xl-0"
                    v-if="offerConfigObj.type_name == 'FNB'"
                  >
                    <custommultiselect
                      v-model="offerConfigObj.selected_fnb_item"
                      :options="FnbItems"
                      :placeholder="'Fnb Items'"
                      label="item_name"
                      isSingleId="item_id"
                      :multiple="false"
                      track-by="item_id"
                      @select="onSelectFnb($event, offerConfigIndex, 'ADD')"
                      @remove="onSelectFnb($event, offerConfigIndex, 'REMOVE')"
                    ></custommultiselect>
                  </div>

                  <div class="oc_inp_group">
                    <div class="d-flex align-items-center">
                      <span class="font-weight-bold">{{ "AT" }}</span
                      >&nbsp;
                      <div class="input-material-sm mx-1 oc_input">
                        <input
                          v-validate="'required|numeric'"
                          :name="`c_dicountValue_${offerConfigIndex}`"
                          :id="`c_dicountValue_${offerConfigIndex}`"
                          v-model="offerConfigObj.c_discount_value"
                          type="number"
                          max="100"
                        />
                      </div>
                      <div class="label-text">
                        &nbsp;<span class="font-weight-bold">
                          {{ "%  OFF" }} </span
                        >&nbsp;
                      </div>
                    </div>
                  </div>

                  <div class="oc_inp_group">
                    <div class="d-flex align-items-center">
                      <span class="font-weight-bold"> {{ "UPTO" }} </span>&nbsp;
                      <div class="input-material-sm mx-1 oc_input">
                        <input
                          v-validate="'required|numeric'"
                          :name="`c_discount_upto_${offerConfigIndex}`"
                          :id="`c_discount_upto_${offerConfigIndex}`"
                          v-model="offerConfigObj.c_discount_upto"
                          type="number"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-1">
                    <button
                      class="btn-transparent"
                      @click="removePassConfig(offerConfigIndex)"
                    >
                      <img
                        src="@/assets/img/icons/minus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
                <div
                  class="row d-flex align-items-center justify-content-center border-top mt-4 mb-5 position-relative"
                >
                  <button
                    @click.prevent.stop="addPassConfig()"
                    class="btn-transparent add-more-button"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.pass_settings
          >
            <span class="fs">Pass Settings</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse id="pass_settings" v-model="sectionCollapse.pass_settings">
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-12">
                <div class="oc_section_head">
                  <div class="d-flex align-items-center mr-2">
                    <span>Movie Pass</span>
                    <div class="mx-2">
                      <b-form-radio
                        value="1"
                        class="j-radio"
                        v-model="moviePassObj.applicable_setting"
                      >
                        <div>{{ "Applicable" }}</div>
                      </b-form-radio>
                    </div>
                    <div class="mx-2">
                      <b-form-radio
                        value="2"
                        class="j-radio"
                        v-model="moviePassObj.applicable_setting"
                      >
                        <div>{{ "Not Applicable" }}</div>
                      </b-form-radio>
                    </div>
                    <span>On Selected Cinemas, Screens, Shows</span>
                  </div>
                </div>
                <div class="row">
                  <div
                    :class="[
                      'mb-1',
                      cinemasList.length > 0 &&
                      cinemasList[0].Cinemas.length > 0 &&
                      moviePassObj.selected_cinemas.length > 5
                        ? 'col-lg-12 col-xl-12'
                        : 'col-lg-4 col-xl-4',
                    ]"
                  >
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          moviePassObj.selected_cinemas.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc("selectCinemas") }}</label
                      >
                      <div class="multiselect">
                        <custommultiselect
                          v-model="moviePassObj.selected_cinemas"
                          :options="cinemasList"
                          :placeholder="''"
                          label="cine_name"
                          :multiple="true"
                          track-by="cine_id"
                          group-values="Cinemas"
                          group-label="label"
                          :group-select="true"
                        >
                        </custommultiselect>
                      </div>
                    </div>
                    <p class="error_message"></p>
                  </div>

                  <div
                    :class="[
                      'mb-1',
                      ScreenList.length > 0 &&
                      moviePassObj.selected_screens.length > 5
                        ? 'col-lg-12 col-xl-12'
                        : 'col-lg-4 col-xl-4',
                    ]"
                  >
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          moviePassObj.selected_screens.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ "Screens" }}</label
                      >
                      <custommultiselect
                        v-model="moviePassObj.selected_screens"
                        :options="filteredScreensList"
                        :placeholder="''"
                        label="screen_name"
                        :multiple="true"
                        track-by="screen_id"
                        group-values="screens"
                        group-label="cinema_name"
                        :group-select="true"
                      >
                        <!-- <template slot="option" slot-scope="props"
                          ><span
                            >{{ props.option.screen_name }} -
                            {{ props.option.cine_name }}</span
                          >
                        </template> -->
                      </custommultiselect>
                    </div>
                    <p class="error_message">
                      <span></span>
                    </p>
                  </div>

                  <div
                    :class="[
                      'mb-1',
                      movieList.length > 0 &&
                      movieList[0].Movies.length > 0 &&
                      moviePassObj.selected_movie_details.length > 5
                        ? 'col-lg-12 col-xl-12'
                        : 'col-lg-4 col-xl-4',
                    ]"
                  >
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          moviePassObj.selected_movie_details.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >{{ $tc("movies") }}</label
                      >
                      <custommultiselect
                        v-model="moviePassObj.selected_movie_details"
                        :options="movieList"
                        label="movie"
                        :placeholder="''"
                        isSingleId="md_id"
                        :multiple="true"
                        track-by="md_id"
                        group-values="Movies"
                        group-label="label"
                        :group-select="true"
                      >
                      </custommultiselect>
                    </div>
                    <p class="error_message">
                      <span></span>
                    </p>
                  </div>

                  <div
                    :class="[
                      'mb-1',
                      aggregatorUsersList.length > 0 &&
                      moviePassObj.selected_sales_channels.length > 5
                        ? 'col-lg-12 col-xl-12'
                        : 'col-lg-4 col-xl-4',
                    ]"
                  >
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          moviePassObj.selected_sales_channels.length > 0
                            ? 'shift-up'
                            : ''
                        "
                        >Sales Channel</label
                      >
                      <custommultiselect
                        v-model="moviePassObj.selected_sales_channels"
                        :options="aggregatorUsersList"
                        :placeholder="''"
                        label="username"
                        :multiple="true"
                        track-by="user_id"
                      >
                      </custommultiselect>
                    </div>
                    <p class="error_message">
                      <span></span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-xl-12 align-self-center mb-2">
                <div class="row">
                  <div class="col-8">
                    <div class="row mx-0 rounded-10 px-2 pt-2">
                      {{ $t("show") }} {{ $t("days") }}:
                      <b-form-checkbox
                        v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                        :key="weekdaysKey"
                        v-model="weekDays[weekdaysKey]"
                        class="j-checkbox mx-2 mb-2 pb-0"
                        @change="onChangeWeekdays($event, weekdaysKey)"
                      >
                        <div class="text-capitalize">{{ weekdaysKey }}</div>
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mb-2">
                      Movie Pass Applicable Between Time Slot.
                    </div>
                    <div class="d-flex">
                      <div class="col-lg-6 custom-timepicker pl-0">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <vue-timepicker
                            manual-input
                            v-model="moviePassObj.from_time"
                            id="from_time"
                            name="from_time"
                            :placeholder="$tc('fromtime')"
                            format="HH:mm"
                            class="time_picker"
                            input-width="100%"
                            auto-scroll
                            lazy
                          ></vue-timepicker>
                        </div>
                      </div>

                      <div class="col-lg-6 custom-timepicker">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <vue-timepicker
                            manual-input
                            v-model="moviePassObj.to_time"
                            id="to_time"
                            name="to_time"
                            :placeholder="$tc('totime')"
                            format="HH:mm"
                            class="time_picker"
                            input-width="100%"
                            auto-scroll
                            lazy
                          ></vue-timepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="error_message"></p>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <section class="mb-2">
        <div class="d-flex">
          <div
            class="section-title mb-2 d-flex justify-content-between section-border section-border col-12"
            style="padding: 6px; align-items: center"
            v-b-toggle.pass_price
          >
            <span class="fs">Movie Pass Price Details</span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
        </div>

        <b-collapse id="pass_price" v-model="sectionCollapse.pass_price">
          <div class="new-border back rounded-10 col-12 pt-3 mb-2">
            <div class="row">
              <div class="col-5">
                <div class="row">
                  <div class="col-6 mb-2">
                    <div class="input-material">
                      <input
                        v-model="moviePassObj.pass_gross_amount"
                        name="pass_gross_amount"
                        id="pass_gross_amount"
                        v-validate="'required'"
                        placeholder="."
                        type="text"
                        @input="handleChangePrice($event)"
                      />
                      <label>Movie Pass Price</label>
                    </div>
                    <p
                      v-if="
                        submitted &&
                          isNaN(String(moviePassObj.pass_gross_amount))
                      "
                      class="error_message"
                    >
                      <span>Required.</span>
                    </p>
                  </div>

                  <div class="col-6 mb-1">
                    <div class="dropdown-curve-container">
                      <label
                        :class="moviePassObj.tax_setting_id ? 'shift-up' : ''"
                      >
                        Charge Setting
                      </label>
                      <multiselect
                        v-model="moviePassObj.selected_tax_settings"
                        placeholder=""
                        :options="ChargeSettingsList"
                        label="pas_charge_setting_name"
                        track-by="pas_id"
                        :multiple="false"
                        name="pas_charge_setting_name"
                        id="pas_charge_setting_name"
                        select-label="Select"
                        deselect-label="Remove"
                        @select="onSelectTaxSetting($event)"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-7">
                <table
                  class="swc-report-table mb-3"
                  border="1"
                  style="table-layout: auto; background: white"
                >
                  <thead>
                    <tr>
                      <th class="p-0" style="width: 240px"></th>
                      <th class="p-0" style="width: 240px"></th>
                      <th class="p-0" style="width: 100px"></th>
                      <th class="p-0" style="width: 100px"></th>
                      <th class="p-0" style="width: 170px"></th>
                      <th class="p-0" style="width: 125px"></th>
                      <th class="p-0" style="width: 125px"></th>
                      <th class="p-0" style="width: 140px"></th>
                      <th class="p-0" style="width: 185px"></th>
                      <th class="p-0" style="width: 140px"></th>
                      <th class="p-0" style="width: 180px"></th>
                    </tr>
                  </thead>
                  <tbody v-if="true">
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="3" class="font-weight-bold text-left">
                        Net Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{ currFormat(moviePassObj["pass_net_amount"] || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="3" class="font-weight-bold text-left">
                        Tax Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{ currFormat(moviePassObj["pass_tax_amount"] || 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="3" class="font-weight-bold text-left">
                        Gross Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{ currFormat(moviePassObj["pass_gross_amount"] || 0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <div class="col-12 mt-4 text-center">
        <button
          :disabled="btenable"
          @click.prevent.stop="OnFinalSubmit(true)"
          class="btn-blue"
        >
          {{ pass_id ? "Update" : $t("generate") }} {{ $t("movie_pass") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import MarketingService from "@/services/MarketingService";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  import { VueEditor } from "vue2-editor";
  import _ from "lodash";

  export default {
    components: { VueTimepicker, VueEditor },
    data() {
      return {
        pass_id: null,
        errorIndex: null,
        groupedScreenList: [],
        aggregatorUsersList: [],
        ChargeSettingsList: [],
        ScreenSeatTypeGroups: [],
        FnbItems: [],
        set_height: null,
        set_width: null,
        showModal: null,
        isEdit: true,
        isEditHtml: false,
        TicketTypes: [],
        messagetickettype: "Please Select Ticket Type",
        btenable: false,

        submitted: false,
        cinemasList: [],
        movieList: [],
        ScreenList: [],
        Cinemas: [],

        selectedExpiry: {
          expiry_id: 3,
          expiry_name: "Year",
          show_input: true,
        },
        expiryArray: [
          {
            expiry_id: 1,
            expiry_name: "Day",
            show_input: true,
          },
          {
            expiry_id: 2,
            expiry_name: "Month",
            show_input: true,
          },
          {
            expiry_id: 3,
            expiry_name: "Year",
            show_input: true,
          },
          {
            expiry_id: 4,
            expiry_name: "Year End",
            show_input: false,
          },
          {
            expiry_id: 5,
            expiry_name: "No Expiry",
            show_input: false,
          },
        ],
        moviePassObj: {
          pass_id: null,
          pass_name: "",
          alt_pass_name: "",
          pass_description: "",
          pass_image_url: "",
          valid_from_date: "",
          valid_to_date: "",
          from_time: "",
          to_time: "",
          expiry_value: "",
          expiry_rule_id: 3,
          pass_expiry_rule: "Year",
          selectedExpiry: {
            expiry_id: 3,
            expiry_name: "Year",
            show_input: true,
          },
          tax_setting_id: null,
          tax_setting_name: "",
          selected_tax_settings: "",
          pass_net_amount: null,
          pass_tax_amount: null,
          pass_gross_amount: null,
          report_code: "",
          gl_account: "",
          gl_desc: "",
          pass_is_active: "Y",
          tax_setting: [],
          charge_array: [],
          //MOVIE VALIDATIONS
          cinema_ids: null,
          selected_cinemas: [],
          screen_ids: null,
          selected_screens: [],
          sstg_ids: null,
          applicable_setting: "1", // IF 1 than applicable on following Else Not Applicable
          selected_seat_type_groups: [],
          md_ids: null,
          selected_movie_details: [],
          sales_channels: null,
          selected_sales_channels: [],
          is_sunday: "Y",
          is_monday: "Y",
          is_tuesday: "Y",
          is_wednesday: "Y",
          is_thursday: "Y",
          is_friday: "Y",
          is_saturday: "Y",
          offer_config: [
            {
              type_id: null,
              type_name: "TICKET",
              c_qty: null,
              selected_sstg_group: "",
              c_item_name: "",
              c_sstg_id: null,
              selected_fnb_item: "",
              c_item_id: null,
              c_item_code: null,
              c_discount_value: null,
              c_discount_upto: null,
            },
          ],
        },

        offerConfigObj: {
          type_id: null,
          type_name: "TICKET",
          c_qty: null,
          selected_sstg_group: "",
          c_item_name: "",
          c_sstg_id: null,
          selected_fnb_item: "",
          c_item_id: null,
          c_item_code: null,
          c_discount_value: null,
          c_discount_upto: null,
        },

        //Collapse
        sectionCollapse: {
          pass_settings: true,
          pass_config: true,
          pass_details: true,
          pass_price: true,
        },

        weekDays: {
          selectAll: true,
          sunday: true,
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
        },
      };
    },
    computed: {
      showErpColumns() {
        return this.$store.getters.SHOW_ERP_GL_FIELDS == "Y" ? true : false;
      },
      filteredScreensList() {
        let finalArray = [...this.groupedScreenList];
        if (this.moviePassObj.selected_cinemas.length) {
          finalArray = finalArray.filter((x) => {
            return this.moviePassObj.selected_cinemas.some(
              (_cine) => _cine.cine_name == x.cinema_name
            );
          });

          this.moviePassObj["selected_screens"] = this.moviePassObj[
            "selected_screens"
          ].filter((x) => {
            return this.moviePassObj["selected_cinemas"].some(
              (_cine) => _cine.cine_name == x.cine_name
            );
          });
        }
        console.log("this.moviePassObj", this.moviePassObj);
        return finalArray;
      },
    },
    watch: {},
    beforeMount() {
      const { pass_id } = this.$route.query;
      this.pass_id = pass_id || null;
      this.getFnBItems();
      this.getScreenSeatTypeGroup();

      if (pass_id) {
        this.getMoviePassInformation(pass_id);
      } else {
        this.getCinemasList();
        this.getActiveMovies();
        this.getScreenList();
        this.getTaxSettings();
        this.getPosAggregatorUsers();
      }
    },
    mounted() {},
    methods: {
      getMoviePassInformation(pass_id) {
        if (pass_id) {
          let loader = this.$loading.show();
          let payload = {
            pass_id: pass_id,
          };
          MarketingService.GetMoviePassDetailsById(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.moviePassObj = data.moviePassObj;
                this.setDaysValue(data.moviePassObj);
                let tempObj = this.expiryArray.find(
                  (_rule) =>
                    _rule["expiry_name"] ==
                    data.moviePassObj["pass_expiry_rule"]
                );
                if (tempObj) {
                  this.moviePassObj["selectedExpiry"] = tempObj;
                }
              } else {
                console.log("Error:", data.message);
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              loader.hide();
              this.getCinemasList();
              this.getActiveMovies();
              this.getScreenList();
              this.getTaxSettings();
              this.getPosAggregatorUsers();
            });
        }
      },
      setDaysValue: function(passObj) {
        let days = {
          monday: "is_monday",
          tuesday: "is_tuesday",
          wednesday: "is_wednesday",
          thursday: "is_thursday",
          friday: "is_friday",
          saturday: "is_saturday",
          sunday: "is_sunday",
        };
        if (passObj) {
          Object.keys(days).map((x) => {
            this.weekDays[x] = passObj[days[x]] === "Y" ? true : false;
          });
          let array = Object.keys(this.weekDays).filter(
            (x) => x != "selectAll" && !this.weekDays[x]
          );
          if (array.length) {
            this.weekDays["selectAll"] = false;
          } else {
            this.weekDays["selectAll"] = true;
          }
        }
      },
      onSelectTaxSetting(taxSetting) {
        this.moviePassObj["tax_setting_id"] = taxSetting.pas_id;
        this.moviePassObj["tax_setting_name"] =
          taxSetting.pas_charge_setting_name;
        this.getCinemaCharges(taxSetting);
      },
      onSelectSeatTypeGroup(event, index, type = "ADD") {
        if (type == "REMOVE") {
          this.moviePassObj["offer_config"][index]["c_sstg_id"] = null;
          this.moviePassObj["offer_config"][index]["c_item_name"] = "";
        } else {
          this.moviePassObj["offer_config"][index]["c_sstg_id"] =
            event["sstg_id"];
          this.moviePassObj["offer_config"][index]["c_item_name"] =
            event["sstg_name"];
        }
      },
      onSelectFnb(event, index, type = "ADD") {
        if (type == "REMOVE") {
          this.moviePassObj["offer_config"][index]["c_item_id"] = null;
          this.moviePassObj["offer_config"][index]["c_item_code"] = null;
          this.moviePassObj["offer_config"][index]["c_item_name"] = "";
        } else {
          this.moviePassObj["offer_config"][index]["c_item_id"] =
            event["item_id"];
          this.moviePassObj["offer_config"][index]["c_item_code"] =
            event["item_code"];
          this.moviePassObj["offer_config"][index]["c_item_name"] =
            event["item_name"];
        }
      },
      onSelectLevel(params) {
        if (!params["show_input"]) {
          this.moviePassObj.expiry_value = null;
        }
        this.moviePassObj["selectedExpiry"] = params;
        this.moviePassObj["pass_expiry_rule"] = params["expiry_name"];
        this.moviePassObj["expiry_rule_id"] = params["expiry_id"];
      },
      handleChangePrice() {
        if (
          this.moviePassObj.pass_gross_amount &&
          this.moviePassObj.tax_setting_id
        ) {
          this.cinemaChargesCalculation();
        }
      },
      getCinemaCharges: function(charge_setting, index = 0) {
        this.moviePassObj.charge_array = [];
        this.moviePassObj.tax_setting = [];

        let cinemaChargesArray = charge_setting["charge_array"] || [];
        this.moviePassObj.charge_array = charge_setting["charge_array"] || [];

        cinemaChargesArray.map((x) => {
          let obj = {
            pas_order: x.pas_order || 0,
            charge_name: x.ct_name,
            cinemacharges: 0,
            charge_value: x.pas_charge_value,
            ct_id: x.ct_id,
            ct_code: x.ct_code,
            pas_id: x.pas_id,
            pas_is_percentage: x.pas_is_percentage,
          };
          this.moviePassObj.tax_setting.push(obj);
        });

        this.cinemaChargesCalculation(index);
      },
      cinemaChargesCalculation: function(listIndex) {
        let tempChargeArray = this.moviePassObj.charge_array;
        if (true) {
          let grosss = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "Y")
            .filter((g) =>
              String(g.ct_name)
                .toUpperCase()
                .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let nets = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "N")
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            )
            .filter((g) => g.pas_is_percentage === "Y");

          let misc_products = this.getSafe(
            () => tempChargeArray.map((x) => x),
            []
          )
            .filter((g) => g.pas_is_percentage === "N")
            .filter(
              (g) =>
                !String(g.ct_name)
                  .toUpperCase()
                  .includes("VAT")
            );

          console.log({
            nets,
            grosss,
            misc_products,
            taxes: tempChargeArray.map((x) => x),
          });

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
          let vat_percent = this.getFloat(
            this.getSafe(() => grosss[0].pas_charge_value, 0)
          );

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
          let net_1_percent = this.getFloat(
            this.getSafe(() => nets[0].pas_charge_value, "0")
          );

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
          let net_2_percent = this.getFloat(
            this.getSafe(() => nets[1].pas_charge_value, "0")
          );

          let misc_product_rate_pas_id = this.getSafe(
            () => misc_products[0].pas_id
          );
          let misc_product_rate_1 = this.getFloat(
            this.getSafe(() => misc_products[0].pas_charge_value, "0")
          );
          let misc_rate_exist =
            misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;
          let amount = this.getFloat(this.moviePassObj.pass_gross_amount || 0);

          /** Gross */
          let G = amount;
          /** Taxable/Net */
          let E = this.getFloat(amount / (1 + vat_percent / 100));
          /** VAT */
          let F = this.getFloat((vat_percent / 100) * E);
          /** 3D/Prod */
          let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
          /** Ticket Rate */
          let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
          let A = this.getFloat((E - B) / totalPerCentOfA);
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A);
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A);

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            totalPerCentOfA,
            misc_rate_exist,
            misc_product_rate_1,
          });
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            "3D": B,
            TicketRate: A,
            ProductRate: B,
          });

          let NET_AMT = E;
          let BASE_RATE = A;
          let NET_1_AMT = C;
          let NET_2_AMT = D;
          let NET_3_AMT = B; // misc_product_rate_1
          let VAT_AMT = F;
          let Gross = G;

          this.moviePassObj.pass_net_amount = parseFloat(BASE_RATE + NET_3_AMT);

          tempChargeArray.map((x, i) => {
            let index = this.moviePassObj.tax_setting.findIndex(
              (zz) => zz.ct_id == x.charge_type_id
            );

            if (x.pas_id == net_1_pas_id) {
              x.cinemacharges = NET_1_AMT;
            }
            if (x.pas_id == net_2_pas_id) {
              x.cinemacharges = NET_2_AMT;
            }
            if (x.pas_id == misc_product_rate_pas_id) {
              x.cinemacharges = NET_3_AMT;
            }

            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = VAT_AMT;
            }

            this.moviePassObj.tax_setting[index].cinemacharges =
              x.cinemacharges || 0;
          });

          let unitNet = parseFloat(this.moviePassObj.pass_net_amount);

          this.moviePassObj.pass_net_amount = parseFloat(
            parseFloat(unitNet || 0)
          ).toFixed(4);

          this.moviePassObj.pass_tax_amount = parseFloat(
            this.moviePassObj.tax_setting.reduce(
              (acc, { cinemacharges }) =>
                acc +
                +parseFloat(cinemacharges || 0).toFixed(
                  this.MIN_FRACTION_DIGITS
                ),
              0
            )
          ).toFixed(this.MIN_FRACTION_DIGITS);
        }
      },
      getFloat(val = "0", fractionDigits = 8) {
        let parsed = parseFloat(String(val) || "0") || parseFloat("0");
        return parseFloat(parsed.toFixed(fractionDigits));
      },
      getPosAggregatorUsers: function() {
        MasterService.GetPosAggregatorUsers()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.aggregatorUsersList = data.Records;

              if (this.moviePassObj["sales_channels"]) {
                let tempArray =
                  this.moviePassObj["sales_channels"].split(", ") || [];
                this.moviePassObj[
                  "selected_sales_channels"
                ] = data.Records.filter((_user) =>
                  tempArray.includes(String(_user.user_id))
                );
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(err);
          });
      },
      getTaxSettings() {
        MasterService.GetTaxSettings()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ChargeSettingsList = data.Records;

              if (this.moviePassObj["tax_setting_id"]) {
                let taxSetting = data.Records.filter(
                  (_pas) => _pas.pas_id == this.moviePassObj["tax_setting_id"]
                );
                if (taxSetting && taxSetting.length) {
                  this.onSelectTaxSetting(taxSetting[0]);
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getFnBItems: function() {
        MarketingService.GetAllFNBItems()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              // console.log("data.Records :>> ", data.Records);
              data.Records.length > 0 ? (this.FnbItems = data.Records) : "";
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      getScreenList() {
        this.groupedScreenList = [];
        MasterService.GetAllCinemaScreenList()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ScreenList = data.Records;

              if (this.moviePassObj["screen_ids"]) {
                let tempArray =
                  this.moviePassObj["screen_ids"].split(", ") || [];
                this.moviePassObj[
                  "selected_screens"
                ] = data.Records.filter((_screen) =>
                  tempArray.includes(String(_screen.screen_id))
                );
              }

              this.groupedScreenList = [];
              let temp_groupedScreenList = [];
              temp_groupedScreenList = _.groupBy(data.Records, "cine_name");
              for (let cinema_name of Object.keys(temp_groupedScreenList)) {
                let obj = {
                  cinema_name: cinema_name,
                  screens: temp_groupedScreenList[cinema_name],
                };
                this.groupedScreenList.push(obj);
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {});
      },
      getScreenSeatTypeGroup() {
        let payload = {
          tableName: "ms_screen_seat_type_group",
          sstg_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ScreenSeatTypeGroups = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      addPassConfig: function() {
        this.moviePassObj["offer_config"].push({
          type_id: null,
          type_name: "TICKET",
          c_qty: null,
          selected_sstg_group: "",
          c_item_name: "",
          c_sstg_id: null,
          selected_fnb_item: "",
          c_item_id: null,
          c_item_code: null,
          c_discount_value: null,
          c_discount_upto: null,
        });
      },
      removePassConfig: function(index) {
        this.moviePassObj["offer_config"].splice(index, 1);
      },
      getTicketTypeList: function() {
        this.TicketTypes = [];
        let body = {
          tableName: "ms_ticket_type",
        };
        MasterService.GetActiveList(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.TicketTypes = data.Records.filter((x) => {
                return x.tt_is_active == "Y";
              });
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      onChangeWeekdays: function(event, keyname) {
        // console.log("event :", event);
        if (keyname !== "selectAll") {
          this.weekDays["selectAll"] = false;
        }
        let len = Object.keys(this.weekDays).length;
        if (keyname === "selectAll" && event) {
          Object.keys(this.weekDays).map((x) => {
            x !== "selectAll" ? (this.weekDays[x] = true) : "";
          });
        } else if (keyname === "selectAll" && !event) {
          Object.keys(this.weekDays).map((x) => {
            x !== "selectAll" ? (this.weekDays[x] = false) : "";
          });
        } else if (keyname !== "selectAll" && this.weekDays.selectAll) {
          this.weekDays["selectAll"] = false;
        }
      },
      getCinemasList: function() {
        this.cinemasList = [];
        let payload = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                this.Cinemas = data.Records;
                this.cinemasList = [
                  {
                    label: "Select All Cinemas",
                    Cinemas: data.Records,
                  },
                ];
                if (this.moviePassObj["cinema_ids"]) {
                  let tempArray =
                    this.moviePassObj["cinema_ids"].split(", ") || [];
                  this.moviePassObj[
                    "selected_cinemas"
                  ] = data.Records.filter((_cine) =>
                    tempArray.includes(String(_cine.cine_id))
                  );
                }
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      getActiveMovies: function() {
        this.movieList = [];
        MovieService.GetActiveMoviesWithFormat({ movieversions: "Y" })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                // this.movieList = data.Records;
                this.movieList = [
                  {
                    label: "Select All Movies",
                    Movies: data.Records,
                  },
                ];

                if (this.moviePassObj["md_ids"]) {
                  let tempArray = this.moviePassObj["md_ids"].split(", ") || [];
                  this.moviePassObj[
                    "selected_movie_details"
                  ] = data.Records.filter((_md) =>
                    tempArray.includes(String(_md.md_id))
                  );
                }
              }
            } else {
              // Show Error Message
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      },
      validationCheck(showMsg = true) {
        this.errorIndex = null;
        let errorMsg = ``;
        let errorCount = 0;
        let errorIndex = null;

        if (!this.moviePassObj["pass_name"]) {
          errorCount++;
          errorMsg = `Please Enter Pass Name`;
        } else if (
          this.moviePassObj["selectedExpiry"] &&
          this.moviePassObj["selectedExpiry"]["show_input"] &&
          !this.moviePassObj["expiry_value"]
        ) {
          errorCount++;
          errorMsg = `Please Enter Valid Exiry Value`;
        } else if (isNaN(String(this.moviePassObj["pass_gross_amount"]))) {
          errorCount++;
          errorMsg = `Please Enter Valid Pass Amount`;
        } else if (!this.moviePassObj["tax_setting_id"]) {
          errorCount++;
          errorMsg = `Please Enter Valid Tax Settings`;
        } else if (!this.moviePassObj["offer_config"].length) {
          errorCount++;
          errorMsg = `Please Enter Pass Configuration`;
        } else if (
          (this.moviePassObj["from_time"] && !this.moviePassObj["to_time"]) ||
          (this.moviePassObj["to_time"] && !this.moviePassObj["from_time"])
        ) {
          errorCount++;
          errorMsg = `Please Enter Valid Time Range`;
        } else if (
          this.moviePassObj["from_time"] &&
          this.moviePassObj["to_time"] &&
          moment(this.moviePassObj["from_time"], "HH:mm").isValid() &&
          moment(this.moviePassObj["to_time"], "HH:mm").isValid() &&
          moment(
            moment(this.moviePassObj["from_time"], "HH:mm").format(
              "YYYY-MM-DD HH:mm"
            )
          ).isAfter(
            moment(this.moviePassObj["to_time"], "HH:mm").format(
              "YYYY-MM-DD HH:mm"
            )
          )
        ) {
          errorCount++;
          errorMsg = `Please Enter Valid Time Range`;
        } else if (
          (this.moviePassObj["from_time"] &&
            !moment(this.moviePassObj["from_time"], "HH:mm").isValid()) ||
          (this.moviePassObj["to_time"] &&
            !moment(this.moviePassObj["to_time"], "HH:mm").isValid())
        ) {
          errorCount++;
          errorMsg = `Please Enter Valid Time Range`;
        } else {
          if (this.moviePassObj["offer_config"].length) {
            this.moviePassObj["offer_config"].forEach((_config, index) => {
              if (isNaN(String(_config["c_qty"])) || !_config["c_qty"]) {
                errorCount++;
                errorMsg = `Please Enter Valid ${_config["type_name"]} Qty.`;
                errorIndex = index;
              } else if (
                _config["type_name"] == "TICKET" &&
                !_config["c_sstg_id"]
              ) {
                errorCount++;
                errorMsg = `Please Select Valid Seat Type`;
                errorIndex = index;
              } else if (
                _config["type_name"] == "FNB" &&
                !_config["c_item_code"]
              ) {
                errorCount++;
                errorMsg = `Please Select Valid Fnb Item`;
                errorIndex = index;
              } else if (
                isNaN(String(_config["c_discount_value"])) ||
                !_config["c_discount_value"]
              ) {
                errorCount++;
                errorMsg = `Please Select Valid Discount Value`;
                errorIndex = index;
              } else if (_config["c_discount_value"] > 100) {
                errorCount++;
                errorMsg = `Discount Percentage Cannot be greater than 100`;
                errorIndex = index;
              }
            });
          }
        }
        if (errorCount > 0) {
          if (showMsg) {
            this.$toasted.show(errorMsg);
          }
          this.errorIndex = errorIndex;
          return false;
        } else {
          this.errorIndex = null;
          return true;
        }
      },
      OnFinalSubmit() {
        let checkValid = this.validationCheck();
        if (checkValid) {
          let loader = this.$loading.show();
          this.btenable = true;
          let payload = {
            pass_id: this.pass_id,
            passDetails: this.moviePassObj,
            weekDays: this.weekDays,
          };
          MarketingService.AddMoviePass(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(
                  data.message || "Movie Pass added successfully"
                );
                this.$router.push({
                  path: "/cinema-manager/movie-pass",
                });
              } else {
                this.$toasted.show(data.message || "Something Went Wrong!");
              }
            })
            .catch((err) => {
              loader.hide();
              console.log("Error:", err);
            })
            .finally(() => {
              loader.hide();
              this.btenable = false;
            });
        }
      },
    },
  };
</script>
<style>
  .custom-date .btn-clearDate {
    right: 30px !important;
  }
  .customDisabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .new-border {
    border: 2px solid #b1b4b8;
  }
  label {
    color: black !important;
  }
  .internal-border-new {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
  }
  .internal-border {
    border: 1px solid var(--blue);
    /*background-color: #e6e6f8;*/
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
    width: 100%;
  }
  .back {
    background-color: #fff;
  }
  .oc_input {
    min-width: 80px !important;
  }
  .oc_input input {
    text-align: center;
    font-weight: 500;
    min-width: 80px !important;
  }
  .oc_inp_group_row {
    gap: 20px;
    margin-bottom: 10px;
  }

  .oc_section_head {
    font-size: 15px;
    margin-bottom: 9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MoviePass/AddMoviePass.vue